import { FC } from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { ShopInfo } from '@domains/storehome-common';

import { Bookmark } from '../components/Bookmark';
import { Coupon } from '../components/Coupon';
import { ShopBasicInfo } from '../components/shop-basic-info/ShopBasicInfo';
import { ShopBasicInfoWrapper } from '../components/shop-basic-info/ShopBasicInfo.styled';
import { Thumbnail } from '../components/shop-basic-info/Thumbnail';
import { useShopInformationService } from '../services/useShopInformationService';

interface Props {
  shop_info: ShopInfo;
  is_cover_view: boolean;
}

export const DefaultShopInformationContainer: FC<React.PropsWithChildren<Props>> = ({ shop_info, is_cover_view }) => {
  const { id, name, typical_image_url, representative_coupon_v2, bookmark_count, is_saved_shop } = shop_info;
  const {
    coupon_ref,
    buying_service_badge,
    seller_badges,
    handleBookmarkClick,
    handleCouponDownloadClick,
    handleInfoButtonClick,
    handleShopNameInfoButtonClick,
    handleBadgeImpression,
    has_info_url,
  } = useShopInformationService({
    shop_info,
  });

  return (
    <Root is_cover={is_cover_view}>
      <Wrap>
        <InfoWrap>
          <ShopBasicInfoWrapper gap={12}>
            <ThumbnailWrapper>
              <Thumbnail image_url={typical_image_url} size={52} />
            </ThumbnailWrapper>
            <ShopBasicInfo
              name={name}
              seller_badges={seller_badges}
              additional_badge={buying_service_badge[0]}
              has_info_url={has_info_url}
              onShopNameClick={handleShopNameInfoButtonClick}
              onInfoClick={handleInfoButtonClick}
              onBadgeImpression={handleBadgeImpression}
            />
          </ShopBasicInfoWrapper>
          <Bookmark
            is_saved_shop={is_saved_shop}
            onClick={handleBookmarkClick}
            bookmark_count={bookmark_count}
            count_color='textSecondary'
            gap={2}
          />
        </InfoWrap>
        {representative_coupon_v2 && (
          <CouponWrapper ref={coupon_ref}>
            <Coupon coupon={representative_coupon_v2} link={`/coupon/box/${id}`} onClick={handleCouponDownloadClick} />
          </CouponWrapper>
        )}
      </Wrap>
    </Root>
  );
};

const Root = styled.div<{ is_cover: boolean }>`
  position: relative;
  padding: 16px 0 16px;
  z-index: 10;
  background-color: ${vars.color.staticWhite};
`;

const Wrap = styled.div`
  padding: 0 16px 0;
`;

const ThumbnailWrapper = styled.div`
  margin: 2px;
`;

const InfoWrap = styled.div`
  display: flex;
  gap: 16px;
  justify-content: space-between;
`;

const CouponWrapper = styled.div`
  margin-top: 16px;
`;
